var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFagArrowdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#7c7c7c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.445 0.794)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.35)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24,
    transform: "translate(-0.445 -0.445)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.942 1.097)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12.361,20.838a8.477,8.477,0,1,1,8.477-8.477,8.477,8.477,0,0,1-8.477,8.477m0,1.884A10.314,10.314,0,1,0,5.021,19.7,10.361,10.361,0,0,0,12.361,22.722Z",
    transform: "translate(-2 -2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M18.71,22.369,15.6,19.261a.895.895,0,0,0-1.413.094.989.989,0,0,0,.094,1.272l3.768,3.72a.895.895,0,0,0,1.319,0l3.768-3.72a.989.989,0,0,0,.094-1.272.895.895,0,0,0-1.413-.094Z",
    transform: "translate(-8.349 -10.972)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFagArrowdown);
export default __webpack_public_path__ + "static/media/fag-arrowdown.d7a73c3cb1c8c0102701b23dacc11796.svg";
export { ForwardRef as ReactComponent };